module.exports = __webpack_public_path__ + "static/media/lab_background_tablet.cea6f36e.jpg";